
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veterinarycover",
      function () {
        return require("private-next-pages/veterinarycover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veterinarycover"])
      });
    }
  